import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pencil, edit, write"><path d="M15.7626 2.67675C16.446 1.99333 17.554 1.99333 18.2374 2.67675L21.3232 5.76253C22.0066 6.44595 22.0066 7.55399 21.3232 8.23741L18.8107 10.75L13.25 5.18931L15.7626 2.67675Z" fill="currentColor"/><path d="M12.1893 6.25L2.51256 15.9268C2.18437 16.255 2 16.7001 2 17.1642V21.25C2 21.6642 2.33579 22 2.75 22H6.83579C7.29991 22 7.74503 21.8156 8.07322 21.4874L17.75 11.8107L12.1893 6.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPencil;
